module.exports = __webpack_public_path__ + "static/media/meu_alho.355d6e63.jpg";